// src/components/sections/Nosotros/MisionVision/MisionVision.jsx
import React, { useEffect, useMemo } from "react";
import "./misionVision.css";
import Loader from "../../../elements/Loader/Loader";
import useStore from "../../../../useStore";
import { useToast } from "../../../../Contexts/Toast/toast.provider";

const Section = ({ data, colClass }) => (
  <div className="row">
    {data.map((item, index) => (
      <div key={index} className={`${colClass} mision-vision-box`}>
        <h2 className="mision-vision-title">{item.nosotrosTitulo}</h2>
        <p
          className="mision-vision-description"
          dangerouslySetInnerHTML={{ __html: item.nosotrosDescripcion }}
        />
      </div>
    ))}
  </div>
);

const MisionVision = () => {
  const nosotros = useStore(state => state.nosotros);
  const loading = useStore(state => state.loading);
  const error = useStore(state => state.error);
  const showToast = useToast();

  // Mostrar toast si hay error cargando datos de Nosotros
  useEffect(() => {
    if (error) {
      showToast("error", `❌ Error al cargar sección de Nosotros: ${error}`);
    }
  }, [error, showToast]);

  // Derivar las secciones de la respuesta de la store
  const secciones = useMemo(() => {
    if (!Array.isArray(nosotros) || nosotros.length === 0) {
      return [];
    }
    return (
      nosotros[0]?.nosotrosComponent?.nosotrosData
      || []
    );
  }, [nosotros]);

  if (loading) return <Loader />;
  if (secciones.length === 0) return null;

  // Primera fila: misión, visión, valores (3 items)
  const primeraFila = secciones.slice(0, 3);
  // Segunda fila: resto de secciones
  const segundaFila = secciones.slice(3);

  return (
    <div className="container mision-vision-container">
      <Section data={primeraFila} colClass="col-md-4" />
      {segundaFila.length > 0 && (
        <Section data={segundaFila} colClass="col-md-12" />
      )}
    </div>
  );
};

export default MisionVision;
